<template>
  <v-container>
    <v-layout column justify-space-around align-space-around>
      <help-button ref="helpbutton" v-show="currentHint">
        <strong>Hint: </strong> {{ currentHint }}
      </help-button>
      <v-flex>
        <span v-if="!isMobile()" class="ma-3" style="font-size: 150%">What is this?</span>
      </v-flex>
      <!-- <paleo v-on:changeLevel="updateLevel($event)"/> -->
      <div
        v-if="
          currentContextImage &&
          $store.state.paleoImages.find(
            (x) => x.filename === currentContextImage.file
          )
        "
        class="ma-3"
      >
        <label>Context:</label>
        <div v-bind:class="{ loading: !isLoaded }">
          <pinch-zoom
            v-show="isLoaded"
            style="
              height: 150px;
              background-size: 100%;
              background-color: rgba(0, 0, 0, 0) !important;
            "
          >
            <v-img
              :src="
                $store.state.paleoImages.find(
                  (x) => x.filename === currentContextImage.file
                ).url
              "
              v-show="isLoaded"
              @load="onImgLoad"
              contain
              max-height="200px"
              max-width="100%"
            ></v-img>
          </pinch-zoom>
        </div>
      </div>
      <div
        v-if="
          currentImage &&
          $store.state.paleoImages.find((x) => x.filename === currentImage.file)
        "
      >
        <div v-bind:class="{ loading: !isLoaded }">
          <v-img
            :src="
              $store.state.paleoImages.find(
                (x) => x.filename === currentImage.file
              ).url
            "
            @load="onImgLoad"
            contain
            max-height="300px"
            max-width="90%"
            style="margin: auto;"
          ></v-img>
        </div>
      </div>
      <!-- ^ Glyph image from firebase ^ -->
      <v-flex ma-3-ns ma-1>
        <span>Transcribe below:</span>
      </v-flex>
      <v-flex>
        <v-form v-on:submit.prevent="onSubmit">
          <v-layout>
            <v-text-field
              spellcheck="false"
              solo
              rounded
              color="secondary"
              label="Answer"
              v-model="userAnswer"
              ref="typeBox"
              autofocus
            ></v-text-field>
          </v-layout>
          <div class="buttons">
            <v-btn @click="handleAnswer" v-if="!answered">Check</v-btn>
            <v-btn @click="clear" v-if="!answered"> Skip </v-btn>
          </div>
        </v-form>
      </v-flex>

      <transition name="fade">
        <v-flex v-if="answered">
          <v-card flat class="answercard">
            <v-container fill-height fluid style="flex-direction: column; justify-content: center;">
              <v-card-text class="centertext" style="width: auto; padding-top: 0; padding-bottom: 24px;">
                <p class="green--text result-text" v-if="correct">
                  Correct!
                </p>
                <p class="red--text result-text" v-else>Incorrect!</p>
                <span class="secondary--text" style="font-size: 150%;">
                  Correct Answer:
                  <h3 v-if="prompt.displayAnswer">
                    {{ prompt.displayAnswer }}
                  </h3>
                  <h3 v-else-if="currentAnswers.length > 0">
                    {{ currentAnswers[0] }}
                  </h3>
                </span>
              </v-card-text>
              <v-btn @click="onSubmit">Next</v-btn>
            </v-container>
          </v-card>
        </v-flex>
      </transition>
    </v-layout>
  </v-container>
</template>

<script>
import PinchZoom from "vue-pinch-zoom";
import HelpButton from "../HelpButton.vue";
export default {
  components: { HelpButton, PinchZoom },
  name: "PaleographyQuestion",
  props: {
    prompt: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      userAnswer: "",
      correct: false,
      answered: false,
      isLoaded: false,
    };
  },
  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    onImgLoad() {
      this.isLoaded = true;
    },
    setFocus() {
      this.$nextTick(() => {
        const theElement = this.$refs.typeBox.$el;
        const input = theElement.querySelector(
          "input:not([type=hidden]),textarea:not([type=hidden])"
        );
        if (input) {
          setTimeout(() => {
            input.focus();
          }, 0);
        }
      });
    },
    onSubmit() {
      if (this.userAnswer == "" && !this.answered) return;
      if (!this.answered) this.handleAnswer();
      else this.clear();
    },
    handleAnswer() {
      var ans = this.userAnswer.toLowerCase().trim();
      this.resetHint();
      this.answered = true;
      this.correct =
        this.currentAnswers.includes(ans) ||
        ans === this.prompt.displayAnswer.toLowerCase().trim();
      this.$emit("check", { correct: this.correct });
    },
    clear() {
      this.resetHint();
      this.$emit("next");
      this.answered = false;
      this.userAnswer = "";
      this.isLoaded = false;
      this.setFocus();
    },
    resetHint() {
      var child = this.$refs.helpbutton;
      child.resetShowHint();
    },
  },
  computed: {
    currentAnswers() {
      return [
        ...new Set(this.prompt.answers.map((x) => x.toLowerCase().trim())),
      ];
    },
    currentImage() {
      return this.prompt ? this.prompt.img : "";
    },
    currentContextImage() {
      return this.prompt ? this.prompt.context : "";
    },
    currentHint() {
      return this.prompt ? this.prompt.hint : "";
    },
  },
};
</script>

<style scoped>
incorrect {
  color: red;
}
.buttons {
  display: flex;
  justify-content: center;
  align-items: center;
}
.loading {
  height: 200px;
  width: 200px;
  margin: auto;
  background: transparent
    url("https://miro.medium.com/max/882/1*9EBHIOzhE1XfMYoKz1JcsQ.gif") center
    no-repeat;
}
.answercard {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.centertext {
  text-align: center !important;
  display: table;
  margin: 0 auto;
}

.result-text{
  font-size: 200%; 
  font-weight: 
  bold; margin: 0;
}
</style>
